import { createRoute } from '@tanstack/react-router';
import { Route as shellRoute } from '../_shell';
import { Alerts } from '@/features/settings/Alerts';

export const Route = createRoute({
  getParentRoute: () => shellRoute,
  path: '/settings/alerts',
  component: Alerts,
});
